import React from "react";

import "./SplashScreen.scss";

const SplashScreen = () => (
	<div className="splash-screen">
		<i className="rkf rkf-rollkall-logo" />
		<i className="rkf rkf-spinner rkf-spin rkf-fw" />
	</div>
);

export default SplashScreen;
